/**
 * Traduções de mensagens de erro comum
 * Converte mensagens em inglês para português
 */

export function translateAuthError(error: string | undefined): string {
  if (!error) return 'Erro ao processar autenticação. Tente novamente.';

  const errorLower = error.toLowerCase();

  // Erros de validação
  if (errorLower.includes('email') && errorLower.includes('invalid')) {
    return 'Email inválido ou não preenchido.';
  }
  if (errorLower.includes('password') && errorLower.includes('required')) {
    return 'Senha é obrigatória.';
  }
  if (errorLower.includes('password') && errorLower.includes('must be at least')) {
    return 'A senha deve ter no mínimo 6 caracteres.';
  }
  if (errorLower.includes('password') && errorLower.includes('must contain')) {
    return 'A senha deve conter letras maiúsculas, números e caracteres especiais.';
  }
  if (errorLower.includes('not found') || errorLower.includes('user not found')) {
    return 'Usuário não encontrado. Por favor, verifique seu email.';
  }
  if (errorLower.includes('invalid credentials') || errorLower.includes('incorrect')) {
    return 'Email ou senha incorretos.';
  }
  if (errorLower.includes('already exists') || errorLower.includes('already registered')) {
    return 'Este email já está registrado.';
  }
  if (errorLower.includes('unauthorized') || errorLower.includes('401')) {
    return 'Acesso não autorizado. Faça login novamente.';
  }
  if (errorLower.includes('forbidden') || errorLower.includes('403')) {
    return 'Você não tem permissão para acessar.';
  }
  if (errorLower.includes('server') || errorLower.includes('500')) {
    return 'Erro no servidor. Tente novamente mais tarde.';
  }
  if (errorLower.includes('network') || errorLower.includes('failed to fetch')) {
    return 'Erro de conexão. Verifique sua internet.';
  }
  if (errorLower.includes('timeout')) {
    return 'Conexão expirou. Tente novamente.';
  }

  // Se for mensagem genérica em inglês, tenta traduzir
  const commonEnglishErrors: Record<string, string> = {
    'invalid email': 'Email inválido.',
    'password required': 'Senha é obrigatória.',
    'email required': 'Email é obrigatório.',
    'login failed': 'Falha ao fazer login.',
    'registration failed': 'Falha ao registrar.',
    'user creation failed': 'Falha ao criar usuário.',
    'request timeout': 'Tempo limite da solicitação excedido.',
    'network error': 'Erro de conexão.',
  };

  for (const [englishError, portugueseError] of Object.entries(commonEnglishErrors)) {
    if (errorLower.includes(englishError)) {
      return portugueseError;
    }
  }

  // Se nenhuma tradução específica, retorna o erro traduzido genericamente
  if (error.length > 100 || error.includes('<')) {
    return 'Erro ao processar autenticação. Tente novamente.';
  }

  return error;
}
